import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qdxfxqwtt: FaireProductEntity = {
  token: "p_7qdxfxqwtt",
  type: "product",
  name: "Cape Citrus Non-alcoholic Spirit Alternative",
  brandToken: "b_g593ctghc8",
  brandName: "Abstinence Spirits",
  imageUrl:
    "https://cdn.faire.com/fastly/f6695b1bd0d186b1f56fd722fefd345ae48315d4e833bbca0a291bf8f1d0ed30.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c0e1223d39adb5cc5e6a9fabd62e4b2b0ce07c3c5e0f73f5e5916edfa05f71f.jpeg",
    "https://cdn.faire.com/fastly/426d742707ae4f0ddbf8dafed7d65813d7360d4766c331451e1d7e4721cc435a.jpeg",
    "https://cdn.faire.com/fastly/ed9039050c21a09223c16bc4caa76bf889e6f0d10caf621a23162b6484f0e361.png",
  ],
  priceDollars: 33.95,
  description:
    "On the Southern-most tip of Africa and home to the incredibly diverse Cape Floral Kingdom, the Western Cape is one of the world’s largest exporters of citrus fruits. Abstinence Cape Citrus draws from this bountiful resource to give you the most delicious medley of citrus flavor, combined with some of its world-renowned indigenous flora.\n\nNO SUGAR | NO ARTIFICAL SWEETENERS | NO COLORANTS\n\nBotanicals: Orange, Lemon, Grapefruit, Buchu, Cassia, Pepper, Fennel, Ginger\n",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:47.125Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
